import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';

@Directive({ selector: '[appVisible]' })
export class OnVisibleDirective implements AfterViewInit, OnDestroy {
  @Output() public appVisible: EventEmitter<any> = new EventEmitter();
  @Input() appVisibleCheckAgain = true;
  nextCheckTimeout?: NodeJS.Timeout;
  private _intersectionObserver?: IntersectionObserver;

  intersectionObserverEntries?: IntersectionObserverEntry[];

  constructor(private _element: ElementRef) {}

  public ngAfterViewInit(): void {
    this._intersectionObserver = new IntersectionObserver((entries) => {
      this.intersectionObserverEntries = entries;
      this.checkForIntersection();
    }, {});
    this._intersectionObserver.observe(this._element.nativeElement as Element);
  }

  public ngOnDestroy(): void {
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
    }
  }

  private checkForIntersection(): boolean {
    if (!this.intersectionObserverEntries) {
      return false;
    }
    for (let i = 0; i < this.intersectionObserverEntries.length; i++) {
      let entry = this.intersectionObserverEntries[i];
      const isIntersecting =
        entry.isIntersecting && entry.target === this._element.nativeElement;

      if (isIntersecting) {
        this.appVisible.emit();
        if (this.nextCheckTimeout) {
          clearTimeout(this.nextCheckTimeout);
        }
        if (this.appVisibleCheckAgain) {
          this.nextCheckTimeout = setTimeout(() => {
            window.requestAnimationFrame(() => {
              this.checkForIntersection();
            });
          }, 400);
        } else {
          this._intersectionObserver?.unobserve(
            this._element.nativeElement as Element,
          );
        }
        return true;
      }
    }
    return false;
  }
}
